import { render, staticRenderFns } from "./brandDialog.vue?vue&type=template&id=5cdfafa4&scoped=true"
import script from "./brandDialog.vue?vue&type=script&lang=js"
export * from "./brandDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cdfafa4",
  null
  
)

export default component.exports